import { Component, OnInit } from '@angular/core'
import { LayoutComponent } from '../layout/layout.component'

@Component({
  selector: 'jml-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  scrollPanelStyle

  constructor(public app: LayoutComponent) {}

  ngOnInit(): void {
    this.onResize()
  }

  // onResize() {
  //     this.scrollPanelStyle = {
  //         "max-height": window.innerHeight * 0.5 + "px",
  //     };
  // }

  onResize() {
    const headerHeight = 5.25 // in rem
    const footerHeight = 2 // in rem
    const availableHeight =
      window.innerHeight -
      (headerHeight + footerHeight) * parseFloat(getComputedStyle(document.documentElement).fontSize)
    this.scrollPanelStyle = { 'max-height': availableHeight - 96 + 'px' }
  }
}
